// import mqtt from 'mqtt'
import * as mqtt from 'mqtt/dist/mqtt.min';
import Vue from 'vue'
// import VLine from '@/custom-component/VLine'
// var vline = VLine

let imei = ''
let appName = ''
let appVendor = ''
let appVersion = ''
let appId = ""
let webId = ""
let modulars = []
let echarts = []

let connection = {
  host: 'jis.joshvm.com',
  port: 443,
  endpoint: '/mqtt',
  options: {
    clean: true, // 保留会话
    connectTimeout: 6000, // 超时时间
    reconnectPeriod: 6000, // 重连时间间隔
    // 认证信息
    clientId: '',
    username: '',
    protocolVersion: 5,
    // password: 'emqx_test',

  }
}

let client = {
  connected: false,
}
let qos = 0
let platformTopic = "/web/persistence"
let platformPayload = {
  APPID: null,
  CODE: "83",
  DATA: null,
  IMEI: null,
  MODULARID: null,
  TYPE: "[REPORTC]",
  WEBID: null,
}

export let showData = {}
export let modelData = {}

export function connectMqtt(param1, param2, param3, param4, param5, param6, topics, param8, param9) {
  // 连接字符串, 通过协议指定使用的连接方式
  // ws 未加密 WebSocket 连接
  // wss 加密 WebSocket 连接
  // mqtt 未加密 TCP 连接
  // mqtts 加密 TCP 连接
  // wxs 微信小程序连接
  // alis 支付宝小程序连接
  imei = param1
  appName = param2
  appVendor = param3
  appVersion = param4
  appId = param5
  webId = param6
  platformPayload.APPID = Number(appId)
  platformPayload.IMEI = imei
  platformPayload.WEBID = Number(webId)
  modulars = param8
  echarts = param9

  connection.options.clientId = param1 + '_' + new Date().getTime()
  connection.options.username = param1 + '_WSS'
  const { host, port, endpoint, options } = connection
  const connectUrl = `wss://${host}:${port}${endpoint}`
  try {
    // console.log(mqtt)
    // console.log(connectUrl)
    // console.log(options)
    client = mqtt.connect(connectUrl, options)
    // console.log("----end")
  } catch (error) {
    console.log('mqtt connect error!' + error)
  }
  client.on('connect', () => {
    // console.log(client.options.protocolVersion);
    console.log('Connection succeeded!' + new Date())
    subscribeMqtt(topics)
  })
  client.on('error', error => {
    console.log('Connection failed' + new Date() + error)
  })

  // 断开发起重连
  client.on('reconnect', error => {
    console.log('reconnect!' + new Date() + error)
  })
  client.on('message', (topic, message) => {
    // console.log(`Received message ${message} from topic ${topic}`)
    var key = topic.substring(topic.lastIndexOf('/') + 1)
    var json = JSON.parse(message)
    var payload = json.payload
    if (json.persistence) {
      let id = modulars.find(item => item.key === key).id
      platformPayload.MODULARID = Number(id)
      platformPayload.DATA = payload
      publishToPlatform(platformTopic, JSON.stringify(platformPayload))
    }
    if (payload.startsWith('{') && payload.endsWith('}')) {
      Vue.set(showData, key, JSON.parse(payload))
      if (echarts[0] == true) {
        window.refreshLine()
      }
      if (echarts[1] == true) {
        window.refreshBar()
      }
      if (echarts[2] == true) {
        window.refreshPie()
      }
      if (echarts[3] == true) {
        window.refreshGauge()
      }
      if (echarts[4] == true) {
        window.refreshLineupg()
      }
      if (echarts[5] == true) {
        window.refreshsector()
      }
      // if (echarts[6] == true) {
      //   window.refreshCustomOHLC()
      // }
    } else {
      Vue.set(showData, key, payload)
    }
  })
}
export function disconnectMqtt() {
  if (client.connected) {
    try {
      client.end()
      client = {
        connected: false,
      }
      console.log('Successfully disconnected!')
    } catch (error) {
      console.log('Disconnect failed!' + error)
    }
  }
}
export function publishMqtt(topic, payload) {
  topic = imei + '/' + appName + '/' + appVendor + '/' + appVersion + '/' + topic
  client.publish(topic, payload, qos, error => {
    if (error) {
      console.log('Publish error!' + error)
    }
    else {
      // console.log(`Publish ${payload} to topic ${topic}`)
    }
  })
}
function publishToPlatform(topic, payload) {
  client.publish(topic, payload, qos, error => {
    if (error) {
      console.log('Publish error!' + error)
    }
    else {
      // console.log(`Publish ${payload} to topic ${topic}`)
    }
  })
}
export function subscribeMqtt(topics) {
  client.subscribe(topics, qos, (error) => {
    if (error) {
      console.log('Subscribe to topics error!' + error)
      return
    }
    console.log('Subscribe to topics!' + topics)
  })
}
export function unsubscribeMqtt(topics) {
  client.unsubscribe(topics, error => {
    if (error) {
      console.log('Unsubscribe error!' + error)
    }
  })
}